import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { mediaConfined } from '@xing-com/layout-tokens';

export const useIsDesktop = (): boolean => {
  const media = mediaConfined;

  const matches = useMatchMedia(media);

  return matches;
};
